(function () {
  // --------------------------------------------------
  // One-time init guard
  // --------------------------------------------------
  if (window.__SKULABS_CHECK_INIT__) {
    console.warn('[SKULabs] check-add already initialized; skipping.');
    return;
  }
  window.__SKULABS_CHECK_INIT__ = true;

  var CHECK_URL = 'https://skulabs-check.onrender.com/check-add'; // <-- CHANGE THIS IF NEEDED
  var AVAILABILITY_URL = 'https://skulabs-check.onrender.com/check-availability';

  // --------------------------------------------------
  // Helpers
  // --------------------------------------------------
  function log() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[SKULabs]');
    console.log.apply(console, args);
  }

  function warn() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[SKULabs]');
    console.warn.apply(console, args);
  }

  function isKitSku(sku) {
    if (!sku) return false;
    var parts = sku.split('-');
    var last = parts[parts.length - 1] || '';
    var size = last.padStart(4, '0');
    // 0500ml & 1000ml kits only
    return size === '0500' || size === '1000';
  }

  function fetchCartLines() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) {
          throw new Error('Failed to fetch /cart.js: ' + res.status);
        }
        return res.json();
      })
      .then(function (cart) {
        var lines = [];
        if (cart && cart.items && cart.items.length) {
          cart.items.forEach(function (item) {
            if (!item) return;
            lines.push({
              sku: item.sku || null,
              quantity: item.quantity || 0,
              productName: item.product_title || item.title || null
            });
          });
        }
        return lines;
      });
  }

  function getProductName() {
    var titleEl = document.querySelector('h1.product_title');
    return titleEl ? titleEl.textContent.trim() : null;
  }

  function gateCheck(newSku, newQty) {
    return fetchCartLines().then(function (cartLines) {
      var payload = {
        cartLines: cartLines,
        newLine: {
          sku: newSku,
          quantity: newQty,
          productName: getProductName()
        }
      };

      log('Calling SKULabs /check-add with payload:', payload);

      return fetch(CHECK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        if (!res.ok) {
          throw new Error('check-add returned non-OK status: ' + res.status);
        }
        return res.json();
      });
    });
  }

  function parseFormBody(body) {
    var obj = {};
    if (typeof body !== 'string') return obj;
    body.split('&').forEach(function (pair) {
      if (!pair) return;
      var parts = pair.split('=');
      var key = decodeURIComponent(parts[0] || '').trim();
      var val = decodeURIComponent(parts[1] || '').trim();
      if (!key) return;
      obj[key] = val;
    });
    return obj;
  }

  function findSkuByVariantId(variantId) {
    if (!variantId) return null;
    // Look for any <select name="id"> option with this variant id
    var selector = "select[name='id'] option[value='" + variantId + "']";
    var opt = document.querySelector(selector);
    if (!opt) {
      warn('No <option> found for variant id:', variantId);
      return null;
    }
    var sku = opt.getAttribute('data-skulabs-sku');
    if (!sku) {
      warn('Option for variant id has no data-skulabs-sku:', opt);
      return null;
    }
    return sku;
  }

  // --------------------------------------------------
  // UI helpers
  // --------------------------------------------------

  // Reload just the .shopify-variation-add-to-cart container from a fresh copy of the page
  function reloadAddToCartContainer() {
    var current = document.querySelector('.shopify-variation-add-to-cart');
    if (!current) {
      warn('No .shopify-variation-add-to-cart found to reload.');
      return;
    }

    fetch(window.location.href, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) {
          throw new Error('Failed to refetch page: ' + res.status);
        }
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.shopify-variation-add-to-cart');
        if (!fresh) {
          warn('No .shopify-variation-add-to-cart found in refetched HTML.');
          return;
        }

        // Replace just the contents so our global XHR patch still applies
        current.innerHTML = fresh.innerHTML;
        log('Reloaded .shopify-variation-add-to-cart contents from server.');
      })
      .catch(function (err) {
        console.error('[SKULabs] Error reloading add-to-cart container:', err);
      });
  }

  function showPersistentMessage(msg) {
    var overlay = document.getElementById('skulabs-message-overlay');
    var messageEl, buttonEl;

    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'skulabs-message-overlay';
      overlay.style.position = 'fixed';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
      overlay.style.display = 'flex';
      overlay.style.alignItems = 'center';
      overlay.style.justifyContent = 'center';
      overlay.style.zIndex = '99999';

      var box = document.createElement('div');
      box.style.background = '#fff';
      box.style.padding = '20px';
      box.style.maxWidth = '400px';
      box.style.width = '90%';
      box.style.borderRadius = '6px';
      box.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
      box.style.fontFamily = 'inherit';
      box.style.textAlign = 'center';

      messageEl = document.createElement('div');
      messageEl.id = 'skulabs-message-text';
      messageEl.style.marginBottom = '16px';
      messageEl.style.whiteSpace = 'pre-wrap';
      box.appendChild(messageEl);

      buttonEl = document.createElement('button');
      buttonEl.type = 'button';
      buttonEl.textContent = 'OK';
      buttonEl.style.display = 'inline-block';
      buttonEl.style.padding = '8px 16px';
      buttonEl.style.border = 'none';
      buttonEl.style.borderRadius = '4px';
      buttonEl.style.cursor = 'pointer';
      buttonEl.style.fontSize = '14px';
      buttonEl.style.backgroundColor = '#333';
      buttonEl.style.color = '#fff';
      buttonEl.style.width = '100%';

      buttonEl.addEventListener('click', function () {
        overlay.style.display = 'none';
        // Instead of trying to guess all the theme’s loading states,
        // just reload the add-to-cart container from the server.
        reloadAddToCartContainer();
      });

      box.appendChild(buttonEl);
      overlay.appendChild(box);
      document.body.appendChild(overlay);
    } else {
      messageEl = document.getElementById('skulabs-message-text');
    }

    if (messageEl) {
      messageEl.textContent = msg;
    }
    overlay.style.display = 'flex';
  }

  // --------------------------------------------------
  // Variant availability checking (grey out unavailable sizes)
  // --------------------------------------------------

  function getMlFromSku(sku) {
    if (!sku) return 0;
    var parts = sku.split('-');
    var last = parts[parts.length - 1] || '';
    var size = last.padStart(4, '0');
    if (size === '0500') return 500;
    if (size === '1000') return 1000;
    return 0;
  }

  function checkAndGreyOutUnavailableVariants() {
    // Find all variant options with kit SKUs
    var options = document.querySelectorAll("select[name='id'] option[data-skulabs-sku]");
    if (!options.length) {
      log('No variant options with data-skulabs-sku found');
      return;
    }

    // Get first kit SKU to check availability
    var firstKitSku = null;
    for (var i = 0; i < options.length; i++) {
      var sku = options[i].getAttribute('data-skulabs-sku');
      if (isKitSku(sku)) {
        firstKitSku = sku;
        break;
      }
    }

    if (!firstKitSku) {
      log('No kit SKUs found in variant options');
      return;
    }

    log('Checking availability for:', firstKitSku);

    // Call the availability endpoint
    fetch(AVAILABILITY_URL + '?sku=' + encodeURIComponent(firstKitSku), {
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error('check-availability returned non-OK status: ' + res.status);
        }
        return res.json();
      })
      .then(function (result) {
        log('Availability response:', result);

        if (!result || result.availableMl === null || result.availableMl === undefined) {
          log('Could not get availability, leaving all variants enabled');
          return;
        }

        var availableMl = result.availableMl;
        log('Available ml:', availableMl);

        // Grey out variants that require more ml than available
        // 1. Handle <select> dropdown options
        options.forEach(function (opt) {
          var sku = opt.getAttribute('data-skulabs-sku');
          if (!isKitSku(sku)) return;

          var requiredMl = getMlFromSku(sku);
          if (requiredMl > availableMl) {
            log('Disabling dropdown option:', sku, 'requires', requiredMl, 'ml but only', availableMl, 'available');
            opt.disabled = true;
            opt.style.color = '#999';
            // Append "- Out of Stock" to the option text if not already there
            if (opt.textContent.indexOf('Out of Stock') === -1) {
              opt.textContent = opt.textContent + ' - Out of Stock';
            }
          }
        });

        // 2. Handle swatch elements (visual buttons)
        // Swatches have data-value like "500ML" or "1000ML"
        var swatches = document.querySelectorAll('.swatch-element');
        swatches.forEach(function (swatch) {
          var dataValue = swatch.getAttribute('data-value');
          if (!dataValue) return;

          // Parse ml from the swatch value (e.g., "500ML" -> 500, "1000ML" -> 1000)
          var match = dataValue.match(/(\d+)\s*ML/i);
          if (!match) return;

          var requiredMl = parseInt(match[1], 10);
          // Only apply to 500ml and 1000ml kit sizes
          if (requiredMl !== 500 && requiredMl !== 1000) return;

          if (requiredMl > availableMl) {
            log('Disabling swatch:', dataValue, 'requires', requiredMl, 'ml but only', availableMl, 'available');
            // Add soldout class (CSS will grey it out)
            swatch.classList.add('soldout');
            swatch.style.opacity = '0.4';
            swatch.style.pointerEvents = 'none';
            // Disable the radio button inside
            var radio = swatch.querySelector('input[type="radio"]');
            if (radio) {
              radio.disabled = true;
            }
            // Add strikethrough to label
            var label = swatch.querySelector('label');
            if (label) {
              label.style.textDecoration = 'line-through';
              label.style.cursor = 'not-allowed';
            }
          }
        });

        // If the currently selected option is disabled, try to select an available one
        var select = document.querySelector("select[name='id']");
        if (select) {
          var selectedOption = select.options[select.selectedIndex];
          if (selectedOption && selectedOption.disabled) {
            // Find first enabled option
            for (var i = 0; i < select.options.length; i++) {
              if (!select.options[i].disabled) {
                select.selectedIndex = i;
                // Trigger change event so the page updates
                var event = new Event('change', { bubbles: true });
                select.dispatchEvent(event);
                break;
              }
            }
          }
        }
      })
      .catch(function (err) {
        console.error('[SKULabs] Error checking availability:', err);
      });
  }

  // Run availability check when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndGreyOutUnavailableVariants);
  } else {
    // DOM already loaded
    checkAndGreyOutUnavailableVariants();
  }

  // --------------------------------------------------
  // XHR interception
  // --------------------------------------------------
  (function patchXHR() {
    var OriginalXHR = window.XMLHttpRequest;
    if (!OriginalXHR) {
      warn('XMLHttpRequest not found; cannot patch.');
      return;
    }

    var origOpen = OriginalXHR.prototype.open;
    var origSend = OriginalXHR.prototype.send;

    OriginalXHR.prototype.open = function (method, url) {
      this.__skulabsMethod = method ? String(method).toUpperCase() : 'GET';
      this.__skulabsUrl = url || '';
      return origOpen.apply(this, arguments);
    };

    OriginalXHR.prototype.send = function (body) {
      var method = this.__skulabsMethod || 'GET';
      var url = this.__skulabsUrl || '';

      var isCartAdd =
        method === 'POST' &&
        typeof url === 'string' &&
        (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/add.js') !== -1);

      if (!isCartAdd) {
        // Not a cart add call; let it pass through
        return origSend.apply(this, arguments);
      }

      // Parse form body to get variant id & quantity
      var data = parseFormBody(typeof body === 'string' ? body : '');
      var variantId = data.id || data.variant_id || null;
      var qty = data.quantity ? parseInt(data.quantity, 10) : 1;
      if (isNaN(qty) || qty <= 0) qty = 1;

      var sku = findSkuByVariantId(variantId);

      if (!sku) {
        log('Could not resolve SKU for cart/add; letting request through. Variant id:', variantId);
        return origSend.apply(this, arguments);
      }

      if (!isKitSku(sku)) {
        log('SKU is not a kit size, letting cart/add XHR proceed:', sku);
        return origSend.apply(this, arguments);
      }

      var xhr = this;
      log('Intercepting cart/add XHR for kit SKU:', sku, 'qty:', qty, 'url:', url);

      // HOLD the XHR, do not send yet
      gateCheck(sku, qty)
        .then(function (result) {
          log('SKULabs /check-add response:', result);

          if (!result || result.allow == null) {
            log('SKULabs response missing "allow"; failing open and sending XHR.');
            origSend.call(xhr, body);
            return;
          }

          if (result.allow) {
            log('SKULabs allowed add-to-cart. Sending original XHR.');
            origSend.call(xhr, body);
          } else {
            var msg =
              result.message ||
              "Sorry, we don't have enough raw material to add that size with the items already in your cart.";

            // Show a persistent modal and DO NOT send the XHR
            showPersistentMessage(msg);
            // Do NOT call origSend – block the add
          }
        })
        .catch(function (err) {
          console.error('[SKULabs] Error during gateCheck; failing open:', err);
          origSend.call(xhr, body);
        });
    };

    log('check-add gating initialized via XHR patch (cart/add.js interceptor).');
  })();
})();
